( function () {
	'use strict';

	function SimpleTableController ( logger ) {
		var self = this;

		function getGridOptions () {
			return self.gridOptions;
		}

		function getShowTable () {
			return self.showTable;
		}

		function getSimpleListLength () {
			return self.gridOptions && self.gridOptions.data.length > 0;
		}

		function activate () {
			logger.info( 'Activated SimpleTableController' );
		}

		activate();

		self.getGridOptions      = getGridOptions;
		self.getShowTable        = getShowTable;
		self.getSimpleListLength = getSimpleListLength;
	}

	angular.module( 'app.report' )
		.controller( 'SimpleTableController', SimpleTableController );

	SimpleTableController.$inject = [ 'logger' ];
} )();
